<div
  [class]="'badglet'"
  [class.primary-bg]="color === 'primary'"
  [class.warn-bg]="color === 'warn'"
  [class.accent-bg]="color === 'accent'"
>
  <ng-content></ng-content>
</div>
